import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Market Position Mapping", desc: "Pinpoint your strategic whitespace and competitive advantage." },
  { title: "Demand Model Design", desc: "Define acquisition channels, content roles, and budget allocation logic." },
  { title: "Journey Engineering", desc: "Align touchpoints from first awareness to closed-won and expansion." },
  { title: "Measurement Framework", desc: "Build KPI hierarchies that connect activity to revenue outcomes." },
  { title: "Execution Playbooks", desc: "Actionable plans your team can operate without strategic drift." },
  { title: "Quarterly Optimization", desc: "Continuous strategy recalibration using fresh signal and performance data." },
];

const DigitalStrategy = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Strategy that"
    titleAccent="de-risks growth."
    subtitle="A practical digital operating blueprint for leadership teams scaling across channels and markets."
    features={features}
    ctaLabel="BOOK STRATEGY SESSION"
  />
);

export default DigitalStrategy;